import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import { getDocFirstSave } from "../../../StateManagement/Reducers/DocumentsState";
import CreateSignature from "../CreateSignature";
import Error from "../../../Modules/StyledComponents/Toastify/Error";
import "./Test.css";
import { ModalTitle, Modal, ModalContainer, Div } from "../../StyledComponents";
import { CancelButton, ModalDialog, SaveButton } from "./Styles";

import { BsXLg } from "react-icons/bs";

const ViewEdit = ({ show, close, filename, filestatus, fileid, forsign }) => {
  // ------------------------------ State And Variables Start------------------------ //
  const dispatch = useDispatch();
  const [inputValues, setInputValues] = useState({});
  const [Signature, setSignature] = useState(false);
  const [selectedSignatureId, setSelectedSignatureId] = useState(null);
  const [image, setImage] = useState("");
  const [imagename, setImagename] = useState("");
  const [viewdocumentdata1, setViewdocumentdata1] = useState("");

  const [ModalAnimat] = useState(true);
  const [ContentForSvaeSign, setContentForSvaeSign] = useState("");
  const SignaturesavesignID = useSelector(
    (state) => state.Document.signaturesavesignID,
  );
  function addBorderToTDs(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");
    const tds = doc.querySelectorAll("td");

    tds.forEach((td) => {
      if (!td.classList.contains("good_faith_estimate_table1")) {
        td.style.border = "1px solid 	#000000";
      }
      td.style.padding = "8px";
    });

    return doc.documentElement.outerHTML;
  }
  function disabledremove(htmlString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(ViewEditDocumentDataval, "text/html");
    const inputElements = doc.querySelectorAll("input, select,img");
    inputElements.forEach((input) => {
      input.removeAttribute("disabled");
    });

    return doc.documentElement.outerHTML;
  }
  const ViewEditDocumentDataBefore = useSelector(
    (state) => state.Document.ViewEditData,
  );
  const ViewEditDocumentDataval = addBorderToTDs(ViewEditDocumentDataBefore);

  const ViewEditDocumentData = disabledremove(ViewEditDocumentDataval);

  const formElementRegex = /<(input|select|checkbox|radio|img|table)/i;
  const checkEditOrNot = formElementRegex.test(ViewEditDocumentData);
  const extractValuesBetweenTildes = (val, placeholder) => {
    const regex = /~(.*?)~/g;
    const matches = [];
    let match;

    while ((match = regex.exec(val)) !== null) {
      matches[match.index - placeholder.length] = match[1];
    }
    return matches;
  };

  let rowCounterMap = {};
  const handlePlaceholderReplace = (placeholder, index, inputValue) => {
    const id = placeholder.replace(/{|}/g, "");
    const value = inputValues[id] || "";
    var valueofArray = extractValuesBetweenTildes(
      ViewEditDocumentData,
      placeholder,
    );
    if (placeholder === "inputbox") {
      return `<input type="text" class="inputbox" data-input-id="${index}" value="${valueofArray[index] !== undefined ? valueofArray[index] : inputValue
        }"></input>`;
    } else if (placeholder === "datepicker") {
      return `<input type="date" data-input-id="${index}" class="datepicker" value="${valueofArray[index] !== undefined ? valueofArray[index] : value
        }"></input>`;
    } else if (placeholder === "signature") {
      return `<p style="font-style: italic;" class="signature" data-input-id="11" data-input-id="${index}" value="${valueofArray[index] !== undefined ? valueofArray[index] : imagename
        }"></input>`;
    } else if (placeholder === "radiobox") {
      return `<input type="radio" class="radiobox" data-input-id="${index}" value="Yes" name="${index}ynRadioGroup"
       ${valueofArray[index] !== undefined && valueofArray[index] === "Yes"
          ? "checked"
          : ""
        }
        >Yes</input>
        <input type="radio" class="radiobox" data-input-id="${index}" value="No" name="${index}ynRadioGroup" ${valueofArray[index] !== undefined && valueofArray[index] === "No"
          ? "checked"
          : ""
        }>No</input>`;
    } else if (placeholder === "radioboxGroup") {
      const lastTrIndex = ViewEditDocumentData.lastIndexOf("<tr", index);

      if (!rowCounterMap.hasOwnProperty(lastTrIndex)) {
        rowCounterMap[lastTrIndex] = 0;
      }

      rowCounterMap[lastTrIndex]++;

      const counter = rowCounterMap[lastTrIndex];

      const name = "radioGroup" + lastTrIndex;

      return `<input type="radio" class="radioboxGroup" data-input-id="${index}" value="${counter}" name="${name}" ${valueofArray[index] !== undefined &&
        valueofArray[index] === counter.toString()
        ? "checked"
        : ""
        }></input>`;
    } else {
      return placeholder;
    }
  };

  const ModifiedStringFin = ViewEditDocumentData.replace(
    /{[^}]+}/g,
    (match, index) => {
      const inputValue = inputValues[match];
      return handlePlaceholderReplace(match, index, inputValue);
    },
  );
  const handleUpdate = () => {
    const ModifiedStringFinal = ModifiedStringFin;

    setViewdocumentdata1(ModifiedStringFinal);
  };
  const duplicateStringBefore = useSelector(
    (state) => state.Document.ViewEditData,
  );
  const duplicateStringDataval = addBorderToTDs(duplicateStringBefore);
  const duplicateString = disabledremove(duplicateStringDataval);
  useEffect(() => {
    const handleInputChange = (event) => {
      const input = event.target;
      const id = input.getAttribute("data-input-id");
      const value = input.value;

      if (input.tagName === "SELECT" && input.type !== "radio") {
        if (input.multiple) {
          const selectedValues = Array.from(input.selectedOptions).map(
            (option) => option.value,
          );

          setInputValues((prevValues) => ({
            ...prevValues,
            [id]: selectedValues,
          }));
        } else {
          const selectedValue = input.value;
          setInputValues((prevValues) => ({
            ...prevValues,
            [id]: selectedValue,
          }));
        }
      } else if (
        input.type === "radio" &&
        input.checked &&
        input.tagName !== "SELECT"
      ) {
        const radioGroupName = input.name;
        const radioButtons = document.querySelectorAll(
          `input[name="${radioGroupName}"]`,
        );
        radioButtons.forEach((radio) => {
          if (radio !== input) {
            radio.removeAttribute("checked");
          }

          input.setAttribute("checked", "checked");
          if (radio.classList.contains("radioboxGroup")) {
            radio.setAttribute("value", "Yes");
          }
        });
        setInputValues((prevValues) => ({
          ...prevValues,
          [id]: value,
        }));
      }
    };

    const handleImageClick = (event) => {
      const signatureId = event.currentTarget.getAttribute("data-input-id");
      if (!signatureId) return;
      setSelectedSignatureId(signatureId);
      setSignature(true);
      setImage("fromimage");
    };

    //   const attachEventListeners = () => {
    //     const selectInputs = document.querySelectorAll("select[data-input-id]");

    //     selectInputs.forEach((select) => {
    //       select.addEventListener("change", handleInputChange);
    //     });

    //     const radioBoxInputs = document.querySelectorAll(
    //       'input[type="radio"].radiobox[data-input-id]',
    //     );
    //     const radioBoxGroupInputs = document.querySelectorAll(
    //       'input[type="radio"].radioboxGroup[data-input-id]',
    //     );

    //     radioBoxInputs.forEach((input) => {
    //       input.addEventListener("change", handleInputChange);
    //     });

    //     radioBoxGroupInputs.forEach((input) => {
    //       input.addEventListener("change", handleInputChange);
    //     });

    //     const signatureImage = document.querySelector(
    //       "img.signature[data-input-id]",
    //     );
    //     if (signatureImage) {
    //       signatureImage.addEventListener("click", handleImageClick);
    //     }
    //     const signatureImages = document.querySelectorAll("img.signature");
    //     signatureImages.forEach((signatureImage) => {
    //       signatureImage.addEventListener("click", handleImageClick);
    //     });
    //     return () => {
    //       selectInputs.forEach((select) => {
    //         select.removeEventListener("change", handleInputChange);
    //       });
    //       radioBoxInputs.forEach((input) => {
    //         input.removeEventListener("change", handleInputChange);
    //       });
    //       radioBoxGroupInputs.forEach((input) => {
    //         input.removeEventListener("change", handleInputChange);
    //       });
    //       if (signatureImage) {
    //         signatureImage.removeEventListener("click", handleImageClick);
    //       }
    //       return () => {
    //         signatureImages.forEach((signatureImage) => {
    //           signatureImage.removeEventListener("click", handleImageClick);
    //         });
    //       };
    //     };
    //   };

    //   const cleanup = attachEventListeners();

    //   const observer = new MutationObserver(() => {
    //     cleanup();
    //     attachEventListeners();
    //   });

    //   observer.observe(document.body, {
    //     childList: true,
    //     subtree: true,
    //   });

    //   return () => {
    //     cleanup();
    //     observer.disconnect();
    //   };
    // }, []);

    const handleRadioMouseDown = (event) => {
      const input = event.target;
      input.wasChecked = input.checked;
    };

    const handleRadioClick = (event) => {
      const input = event.target;
      if (input.wasChecked) {
        input.checked = false;
        input.removeAttribute("checked");
        const radioGroupName = input.name;
        if (radioGroupName) {
          const radioButtons = document.querySelectorAll(
            `input[name="${radioGroupName}"]`,
          );
          radioButtons.forEach((radio) => {
            radio.checked = false;
            radio.removeAttribute("checked");
          });
        }
        const id = input.getAttribute("data-input-id");
        if (id) {
          setInputValues((prevValues) => ({
            ...prevValues,
            [id]: "",
          }));
        }
        input.wasChecked = false;
      }
    };

    const attachEventListeners = () => {
      const selectInputs = document.querySelectorAll("select[data-input-id]");

      selectInputs.forEach((select) => {
        select.addEventListener("change", handleInputChange);
      });

      const radioBoxInputs = document.querySelectorAll(
        'input[type="radio"].radiobox[data-input-id]',
      );
      const radioBoxGroupInputs = document.querySelectorAll(
        'input[type="radio"].radioboxGroup[data-input-id]',
      );

      radioBoxInputs.forEach((input) => {
        input.addEventListener("change", handleInputChange);
        input.addEventListener("mousedown", handleRadioMouseDown);
        input.addEventListener("click", handleRadioClick);
      });

      radioBoxGroupInputs.forEach((input) => {
        input.addEventListener("change", handleInputChange);
        input.addEventListener("mousedown", handleRadioMouseDown);
        input.addEventListener("click", handleRadioClick);
      });

      const signatureImage = document.querySelector(
        "img.signature[data-input-id]",
      );
      if (signatureImage) {
        signatureImage.addEventListener("click", handleImageClick);
      }
      const signatureImages = document.querySelectorAll("img.signature");
      signatureImages.forEach((signatureImage) => {
        signatureImage.addEventListener("click", handleImageClick);
      });
      const handleErrorClear = (e) => {
        const input = e.target;
        const nextEl = input.nextElementSibling;
        if (nextEl && nextEl.classList.contains("field-error")) {
          nextEl.remove();
        }
        if (input.value.trim() !== "") {
          input.style.border = "";
        }
      };

      const textInputs = document.querySelectorAll(
        "input:not([type='radio']), textarea",
      );
      textInputs.forEach((input) => {
        input.addEventListener("input", handleErrorClear);
      });

      const handleSelectErrorClear = (e) => {
        const sel = e.target;
        const hasSelection = sel.multiple
          ? Array.from(sel.options).some((opt) => opt.selected)
          : sel.value !== "" &&
          sel.value !== "Select multiple opt" &&
          sel.value !== "Please Select One" &&
          sel.value !== "Please Select an Option";

        if (hasSelection) {
          sel.style.border = "";
          const nextEl = sel.nextElementSibling;
          if (nextEl && nextEl.classList.contains("field-error")) {
            nextEl.remove();
          }
        }
      };

      const selectInputsForError = document.querySelectorAll(
        "select[data-input-id]",
      );
      selectInputsForError.forEach((select) => {
        select.addEventListener("change", handleSelectErrorClear);
      });

      return () => {
        selectInputs.forEach((select) => {
          select.removeEventListener("change", handleInputChange);
        });
        radioBoxInputs.forEach((input) => {
          input.removeEventListener("change", handleInputChange);
          input.removeEventListener("mousedown", handleRadioMouseDown);
          input.removeEventListener("click", handleRadioClick);
        });
        radioBoxGroupInputs.forEach((input) => {
          input.removeEventListener("change", handleInputChange);
          input.removeEventListener("mousedown", handleRadioMouseDown);
          input.removeEventListener("click", handleRadioClick);
        });
        if (signatureImage) {
          signatureImage.removeEventListener("click", handleImageClick);
        }

        textInputs.forEach((input) => {
          input.removeEventListener("input", handleErrorClear);
        });

        selectInputsForError.forEach((select) => {
          select.removeEventListener("change", handleSelectErrorClear);
        });
        return () => {
          signatureImages.forEach((signatureImage) => {
            signatureImage.removeEventListener("click", handleImageClick);
          });
        };
      };
    };

    const cleanup = attachEventListeners();

    const observer = new MutationObserver(() => {
      cleanup();
      attachEventListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      cleanup();
      observer.disconnect();
    };
  }, []);
  // ------------------------------State And Variables End------------------------ //

  // ------------------------------Functions Start------------------------------- //

  const validateForm = () => {
    let hasError = false;

    document.querySelectorAll(".field-error").forEach((el) => el.remove());

    const processedRadioGroups = new Set();
    const inputs = document.querySelectorAll(
      "input[data-input-id], select[data-input-id], textarea[data-input-id]",
    );
    inputs.forEach((input) => {
      let isValid = true;

      if (
        input.type !== "radio" &&
        input.tagName !== "SELECT" &&
        input.value.trim() === ""
      ) {
        isValid = false;
      }

      if (input.tagName === "SELECT") {
        const inputId = input.getAttribute("data-input-id");
        if (!inputId || inputId === "null") return;

        let hasSelection = false;

        if (input.multiple) {
          hasSelection = Array.from(input.options).some(
            (opt) => opt.selected && opt.value !== "",
          );
        } else {
          hasSelection =
            input.value !== "" &&
            input.value !== "Select multiple opt" &&
            input.value !== "Please Select an Option";
        }

        if (!hasSelection) {
          hasError = true;
          input.style.border = "1px solid red";

          const existingError = input.nextElementSibling;
          if (
            existingError &&
            existingError.classList.contains("field-error")
          ) {
            existingError.remove();
          }

          const error = document.createElement("span");
          error.className = "field-error";
          error.style.color = "red";
          error.style.fontSize = "12px";
          error.style.display = "block";
          error.style.marginTop = "2px";
          error.innerText = "Please select an Option";
          input.insertAdjacentElement("afterend", error);
        } else {
          input.style.border = "";
          const existingError = input.nextElementSibling;
          if (
            existingError &&
            existingError.classList.contains("field-error")
          ) {
            existingError.remove();
          }
        }

        return;
      }
      if (input.type === "radio") {
        const groupName = input.name;

        if (processedRadioGroups.has(groupName)) return;
        processedRadioGroups.add(groupName);

        const group = document.getElementsByName(groupName);
        const checked = Array.from(group).some((r) => r.checked);

        if (!checked) {
          hasError = true;

          const lastRadio = group[group.length - 1];

          const error = document.createElement("div");
          error.className = "field-error";
          error.style.color = "red";
          error.style.fontSize = "12px";
          error.innerText = "Please select on Option";

          lastRadio.parentNode.appendChild(error);
        }

        return;
      }
      if (!isValid) {
        hasError = true;

        const inputRect = input.getBoundingClientRect();
        const parentRect = input.parentElement.getBoundingClientRect();

        input.style.border = "1px solid red";

        const error = document.createElement("span");
        error.className = "field-error";
        error.style.color = "red";
        error.style.fontSize = "12px";
        error.style.display = "block";
        error.style.marginTop = "2px";
        // error.style.marginLeft = input.offsetLeft + "px";
        error.innerText = "This field can't be empty";
        error.style.paddingLeft = inputRect.left - parentRect.left + "px";
        input.insertAdjacentElement("afterend", error);
      } else {
        input.style.border = "";
      }
    });

    const firstError = document.querySelector(".field-error");
    if (firstError) {
      const prevEl = firstError.previousElementSibling;
      const targetEl =
        prevEl &&
          (prevEl.tagName === "INPUT" ||
            prevEl.tagName === "SELECT" ||
            prevEl.tagName === "TEXTAREA")
          ? prevEl
          : firstError;

      const scrollContainer =
        document
          .querySelector("#unique-document-viewer-123")
          ?.closest("[style*='overflow']") ||
        document.querySelector(".modal-body") ||
        firstError.closest(
          "[style*='overflow: auto'], [style*='overflow:auto']",
        );

      if (scrollContainer) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const targetRect = targetEl.getBoundingClientRect();
        const offset =
          targetRect.top - containerRect.top + scrollContainer.scrollTop - 100;
        scrollContainer.scrollTo({ top: offset, behavior: "smooth" });
      } else {
        targetEl.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      setTimeout(() => {
        if (
          prevEl &&
          (prevEl.tagName === "INPUT" ||
            prevEl.tagName === "SELECT" ||
            prevEl.tagName === "TEXTAREA")
        ) {
          prevEl.focus();
        }
      }, 400);
    }

    return hasError;
  };

  const CloseSignature = () => {
    setImagename("");
    close();
  };

  const SaveSignature = () => {
    const inputValues1 = {};
    const inputElements1 = document.querySelectorAll("input, select");
    let AddSign = false;

    inputElements1.forEach((inputElement) => {
      const inputId1 = inputElement.getAttribute("data-input-id");
      const inputValue1 = inputElement.value || "";

      const imgElement = document.querySelector(".signature");

      if (
        (inputElement.tagName === "SELECT" &&
          ((inputElement.multiple &&
            (!inputValues1[inputId1] || inputValues1[inputId1].length === 0)) ||
            (!inputElement.multiple &&
              inputElement.value === "Please Select an Option"))) ||
        (inputElement.type === "radio" &&
          !inputElement.classList.contains("radioboxGroup") &&
          !Array.from(document.getElementsByName(inputElement.name)).some(
            (radio) => radio.checked,
          )) || // No radio selected
        (inputElement.type !== "radio" &&
          inputElement.tagName !== "SELECT" &&
          inputValue1 === "") || // Empty text input
        (imgElement && imgElement.src && imgElement.src.trim() !== "")
      ) {
        AddSign = true;
      }
    });

    if (AddSign) {
      setSignature(true);
      setImage("notimage");
    } else {
      toast(<Error msg="To Sign, Fill Your Details and Save" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  };

  /////////////////////////////////ADD////////////////////

  const HanldeCloseSignature = () => {
    setSignature(false);
  };
  const HanldeCloseSignatureSave = () => {
    setSignature(false);
    close();
  };
  const HanldeCloseSignatureSave1 = () => {
    setSignature(false);
  };
  const handleChildData = (data) => {
    if (!selectedSignatureId) return;
    const modifiedString = setStringreplace();
    setViewdocumentdata1(
      updateImageInDocument(modifiedString, data, selectedSignatureId),
    );
    setImagename(data);
    setSelectedSignatureId(null);
  };

  const setStringreplace = () => {
    const inputValues = {};
    const tableValues = {};

    // Capture input and select values
    const inputElements = document.querySelectorAll("input, select");

    inputElements.forEach((inputElement) => {
      const inputId = inputElement.getAttribute("data-input-id");
      let inputValue = inputElement.value;

      if (inputElement.type === "radio" && inputElement.checked === true) {
        inputValue = inputElement.value;
        inputValues[inputId] = inputValue;
      } else if (inputElement.tagName === "SELECT" && inputElement.multiple) {
        const selectedValues = Array.from(inputElement.selectedOptions).map(
          (option) => option.value,
        );
        inputValues[inputId] = selectedValues;
      } else if (inputElement.tagName === "SELECT") {
        inputValues[inputId] = inputValue;
      }

      if (inputElement.type !== "radio" && inputElement.tagName !== "SELECT") {
        inputValues[inputId] = inputValue;
      }
    });

    // Now capture table data from processed tables
    const processedTables = document.querySelectorAll(
      ".editable-content-table",
    );

    processedTables.forEach((table) => {
      const tableId = table.getAttribute("data-table-id");
      const tableData = [];
      const rows = table.querySelectorAll("tr");

      rows.forEach((row, rowIndex) => {
        const rowData = [];
        const cells = row.querySelectorAll(".editable-content-cell");

        cells.forEach((cell, cellIndex) => {
          let cellContent = cell.innerHTML.trim();
          cellContent = cellContent.replace(/&nbsp;/g, " ").trim();

          // Clean up empty content
          if (cellContent === "<br>" || cellContent === "") {
            cellContent = "";
          }

          rowData.push({
            content: cellContent,
            isHeader: cell.tagName === "TH",
            row: rowIndex,
            cell: cellIndex,
            tableId: tableId,
            cellId: cell.getAttribute("data-cell-index"),
            isEditable: cell.getAttribute("contenteditable") === "true",
          });
        });

        if (rowData.length > 0) {
          tableData.push(rowData);
        }
      });

      if (tableData.length > 0) {
        tableValues[`editable_table_${tableId}`] = {
          data: tableData,
          html: table.outerHTML,
        };
      }
    });

    // Update input and select elements in the original duplicateString
    const modifiedStringEditSave = duplicateString.replace(
      /<input[^>]+data-input-id="(\d+)"[^>]*>/g,
      (match, id) => {
        const inputValue = inputValues[id] || "";
        const isRadiobox = /class="radiobox"/.test(match);
        const isRadioboxGroup = /class="radioboxGroup"/.test(match);
        let isChecked = false;

        if (isRadiobox) {
          const radioMatch = match.match(/value="([^"]*)"/);
          if (radioMatch) {
            const radioValue = radioMatch[1];
            isChecked = inputValue === radioValue;
          }
          return match
            .replace(/checked="checked"/g, "")
            .replace(/>/, isChecked ? ' checked="checked">' : ">");
        }

        if (isRadioboxGroup) {
          const radioMatch = match.match(/data-input-id="([^"]*)"/);
          if (radioMatch !== null) {
            const radioDataInputId = radioMatch[1];
            if (inputValues[radioDataInputId] != null) {
              const radioValueMatch = match.match(/value="([^"]*)"/);
              const radioValue =
                radioValueMatch && radioValueMatch[1] !== ""
                  ? radioValueMatch[1]
                  : inputValues[radioDataInputId];
              isChecked = inputValues[radioDataInputId] === radioValue;
              return match
                .replace(/checked="checked"/g, "")
                .replace(
                  /value="[^"]*"/,
                  isChecked ? `value="${radioValue}"` : "",
                )
                .replace(/>/, isChecked ? ' checked="checked" >' : " >");
            }
          }
        }

        return match.replace(/value="[^"]*"/, `value="${inputValue}"`);
      },
    );

    const updatedStringWithSelect = modifiedStringEditSave.replace(
      /<select[^>]+id=["'](\d+)["'][^>]*>[\s\S]*?<\/select>/g,
      (match, id) => {
        const inputValue = inputValues[id];
        const selectedValues = Array.isArray(inputValue)
          ? inputValue
          : inputValue
            ? [inputValue]
            : [];

        const updatedSelect = match.replace(
          /<option[^>]+value="([^"]+)"[^>]*>/g,
          (optionMatch, optionValue) => {
            const isSelected = selectedValues.includes(optionValue);
            return optionMatch
              .replace(/selected="selected"/g, "")
              .replace(">", isSelected ? ' selected="selected">' : ">");
          },
        );

        return updatedSelect;
      },
    );

    let finalContent = updatedStringWithSelect;

    // APPLY TABLE DATA TO FINAL CONTENT
    if (Object.keys(tableValues).length > 0) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(finalContent, "text/html");

      // Process all tables in the final content
      const contentTables = doc.querySelectorAll("table");

      contentTables.forEach((table, index) => {
        const tableKey = `editable_table_${index}`;

        if (tableValues[tableKey]) {
          const tableData = tableValues[tableKey].data;
          const rows = table.querySelectorAll("tr");

          tableData.forEach((rowData, rowIndex) => {
            if (rows[rowIndex]) {
              const cells = rows[rowIndex].querySelectorAll("td, th");

              rowData.forEach((cellData) => {
                if (cells[cellData.cell]) {
                  // Update editable cells with captured content
                  cells[cellData.cell].innerHTML = cellData.content || "&nbsp;";
                }
              });
            }
          });
        }
      });

      finalContent = doc.body.innerHTML;
    }
    // Preserve live textarea and checkbox state after table content is restored.
    const liveFields = document
      .querySelector("#unique-document-viewer-123")
      ?.querySelectorAll(
        'textarea[data-input-id], input[type="checkbox"][data-input-id]',
      );
    if (liveFields?.length) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(finalContent, "text/html");
      liveFields.forEach((field) => {
        const id = CSS.escape(field.getAttribute("data-input-id"));
        const selector =
          field.tagName === "TEXTAREA"
            ? `textarea[data-input-id="${id}"]`
            : `input[type="checkbox"][data-input-id="${id}"]`;
        const savedField = doc.querySelector(selector);
        if (!savedField) return;
        if (field.tagName === "TEXTAREA") {
          savedField.textContent = field.value;
        } else if (field.checked) {
          savedField.setAttribute("checked", "checked");
        } else {
          savedField.removeAttribute("checked");
        }
      });
      finalContent = doc.body.innerHTML;
    }

    // return;
    const targetContainer = document.querySelector(".target-container");
    if (targetContainer) {
      targetContainer.innerHTML = finalContent;
    }

    return finalContent;
  };

  // const handleSave = () => {
  //   const modifiedString = setStringreplace();
  //   // return;
  //   const parser = new DOMParser();
  //   const doc = parser.parseFromString(modifiedString, "text/html");

  //   if (imagename !== "" && imagename !== undefined && imagename !== null) {
  //     doc.querySelectorAll("img.signature").forEach((img) => {
  //       const id = img.getAttribute("data-input-id");
  //       const p = document.createElement("p");
  //       p.style.fontFamily = "Shadows Into Light";
  //       p.style.fontSize = "18pt";
  //       p.style.fontWeight = "lighter";
  //       p.setAttribute("data-input-id", id);
  //       p.setAttribute("class", "signature");
  //       p.textContent = imagename;
  //       const parent = img.parentElement;

  //       if (parent && parent.tagName === "STRONG") {
  //         parent.replaceWith(p); // remove strong completely
  //       } else {
  //         img.replaceWith(p);
  //       }
  //     });
  //   }

  //   const finalContent = doc.body.innerHTML;
  //   setContentForSvaeSign(finalContent);
  //   dispatch(
  //     getDocFirstSave({
  //       content: finalContent,
  //       id: fileid,
  //       type: "Add",
  //     }),
  //   );
  //   close();
  // };

  // ─── FIXED: SaveSignatureEdit now stamps live values onto HTML attributes
  // before cloneNode so the clone captures what the user actually typed. ───────

  // const handleSave = () => {
  // const viewerContainer = document.querySelector("#unique-document-viewer-123");
  // if (!viewerContainer) return;

  // // Stamp live input values back onto attributes before cloning
  // viewerContainer.querySelectorAll("input").forEach((liveInput) => {
  //   if (liveInput.type === "radio" || liveInput.type === "checkbox") {
  //     if (liveInput.checked) {
  //       liveInput.setAttribute("checked", "checked");
  //     } else {
  //       liveInput.removeAttribute("checked");
  //     }
  //   } else {
  //     liveInput.setAttribute("value", liveInput.value);
  //   }
  // });
  const handleSave = () => {
    const viewerContainer = document.querySelector("#unique-document-viewer-123");
    if (!viewerContainer) return;

    // Stamp live values; fall back to the restored value from viewdocumentdata1
    viewerContainer.querySelectorAll("input").forEach((liveInput) => {
      if (liveInput.type === "radio" || liveInput.type === "checkbox") {
        liveInput.checked
          ? liveInput.setAttribute("checked", "checked")
          : liveInput.removeAttribute("checked");
      } else {
        // If user hasn't typed anything, the value attr from the restored HTML
        // is already correct — don't overwrite it with an empty string
        if (liveInput.value.trim() !== "") {
          liveInput.setAttribute("value", liveInput.value);
        }
      }
    });

    viewerContainer.querySelectorAll("select").forEach((liveSelect) => {
      Array.from(liveSelect.options).forEach((option) => {
        if (option.selected) {
          option.setAttribute("selected", "selected");
        } else {
          option.removeAttribute("selected");
        }
      });
    });

    viewerContainer.querySelectorAll("textarea").forEach((liveTextarea) => {
      liveTextarea.textContent = liveTextarea.value;
    });

    const clonedDoc = viewerContainer.cloneNode(true);

    // Replace inputs with spans showing their values
    clonedDoc.querySelectorAll("input").forEach((clonedInput) => {
      const inputId = clonedInput.getAttribute("data-input-id");
      const liveInput = viewerContainer.querySelector(
        `input[data-input-id="${inputId}"]`,
      );

      if (liveInput) {
        if (liveInput.type === "radio" || liveInput.type === "checkbox") {
          if (liveInput.checked) {
            const span = document.createElement("span");
            span.style.fontWeight = "bold";
            span.textContent = liveInput.value;
            clonedInput.replaceWith(span);
          } else {
            clonedInput.remove();
          }
        } else {
          const span = document.createElement("span");
          span.style.display = "inline-block";
          span.style.minWidth = "50px";
          span.style.borderBottom = "1px solid #000";
          span.style.padding = "0 5px";
          span.textContent = liveInput.value || "\u00A0";
          clonedInput.replaceWith(span);
        }
      }
    });

    // Replace selects with spans showing selected text
    clonedDoc.querySelectorAll("select").forEach((clonedSelect) => {
      const inputId = clonedSelect.getAttribute("data-input-id");
      const liveSelect = viewerContainer.querySelector(
        `select[data-input-id="${inputId}"]`,
      );

      if (liveSelect) {
        const span = document.createElement("span");
        span.style.display = "inline-block";
        span.style.minWidth = "50px";
        span.style.borderBottom = "1px solid #000";
        span.style.padding = "0 5px";

        if (liveSelect.multiple) {
          span.textContent =
            Array.from(liveSelect.selectedOptions)
              .map((o) => o.text)
              .join(", ") || "\u00A0";
        } else {
          span.textContent =
            liveSelect.options[liveSelect.selectedIndex]?.text ||
            liveSelect.value ||
            "\u00A0";
        }
        clonedSelect.replaceWith(span);
      }
    });

    const finalContent = clonedDoc.innerHTML;
    setContentForSvaeSign(finalContent);
    dispatch(
      getDocFirstSave({
        content: finalContent,
        id: fileid,
        type: "Add",
      }),
    );
    close();
  };
  const SaveSignatureEdit = () => {
    const viewerContainer = document.querySelector(
      "#unique-document-viewer-123",
    );
    if (!viewerContainer) return;

    // Stamp live input values back onto attributes before cloning
    viewerContainer.querySelectorAll("input").forEach((liveInput) => {
      if (liveInput.type === "radio" || liveInput.type === "checkbox") {
        if (liveInput.checked) {
          liveInput.setAttribute("checked", "checked");
        } else {
          liveInput.removeAttribute("checked");
        }
      } else {
        liveInput.setAttribute("value", liveInput.value);
      }
    });

    viewerContainer.querySelectorAll("select").forEach((liveSelect) => {
      Array.from(liveSelect.options).forEach((option) => {
        if (option.selected) {
          option.setAttribute("selected", "selected");
        } else {
          option.removeAttribute("selected");
        }
      });
    });

    viewerContainer.querySelectorAll("textarea").forEach((liveTextarea) => {
      liveTextarea.textContent = liveTextarea.value;
    });

    const clonedDoc = viewerContainer.cloneNode(true);
    let hasError = false;

    clonedDoc.querySelectorAll("input").forEach((clonedInput) => {
      const inputId = clonedInput.getAttribute("data-input-id");
      const liveInput = viewerContainer.querySelector(
        `input[data-input-id="${inputId}"]`,
      );

      if (liveInput) {
        let valueText =
          liveInput.type === "radio" || liveInput.type === "checkbox"
            ? liveInput.checked
              ? "[X] "
              : "[ ] "
            : liveInput.value;

        if (
          !liveInput.disabled &&
          liveInput.type !== "radio" &&
          liveInput.type !== "checkbox" &&
          liveInput.value.trim() === ""
        ) {
          hasError = true;
        }

        const span = document.createElement("span");
        span.style.display = "inline-block";
        span.style.minWidth = "50px";
        if (liveInput.type !== "radio" && liveInput.type !== "checkbox") {
          span.style.borderBottom = "1px solid #000";
          span.style.padding = "0 5px";
        }
        span.textContent =
          liveInput.type === "radio" || liveInput.type === "checkbox"
            ? valueText
            : liveInput.value || "\u00A0";
        clonedInput.replaceWith(span);
      }
    });

    clonedDoc.querySelectorAll("select").forEach((clonedSelect) => {
      const inputId = clonedSelect.getAttribute("data-input-id");
      const liveSelect = viewerContainer.querySelector(
        `select[data-input-id="${inputId}"]`,
      );

      if (liveSelect) {
        let selectedTexts = [];
        if (liveSelect.multiple) {
          selectedTexts = Array.from(liveSelect.selectedOptions).map(
            (opt) => opt.text,
          );
          if (!liveSelect.disabled && selectedTexts.length === 0)
            hasError = true;
        } else {
          if (
            liveSelect.value &&
            liveSelect.value !== "Please Select One" &&
            liveSelect.value !== "Please Select an Option"
          ) {
            selectedTexts.push(
              liveSelect.options[liveSelect.selectedIndex].text,
            );
          }
          if (
            !liveSelect.disabled &&
            (liveSelect.value === "" ||
              liveSelect.value === "Please Select One" ||
              liveSelect.value === "Please Select an Option")
          ) {
            hasError = true;
          }
        }

        const span = document.createElement("span");
        span.style.display = "inline-block";
        span.style.minWidth = "50px";
        span.style.borderBottom = "1px solid #000";
        span.style.padding = "0 5px";
        span.textContent = selectedTexts.join(", ") || "\u00A0";
        clonedSelect.replaceWith(span);
      }
    });

    clonedDoc.querySelectorAll("table").forEach((clonedTable) => {
      const tableId = clonedTable.getAttribute("data-table-id");
      const liveTable = viewerContainer.querySelector(
        `table[data-table-id="${tableId}"]`,
      );

      if (liveTable) {
        const clonedCells = clonedTable.querySelectorAll("td, th");
        const liveCells = liveTable.querySelectorAll("td, th");

        liveCells.forEach((liveCell, cellIndex) => {
          if (
            liveCell.getAttribute("contenteditable") === "true" &&
            clonedCells[cellIndex]
          ) {
            clonedCells[cellIndex].innerHTML =
              liveCell.innerHTML.trim() || "&nbsp;";
          }
        });
      }
    });

    if (hasError) {
      toast(<Error msg="To Sign, Fill Your Details and Save" />, {
        containerId: "B",
        className: "error_badge",
      });
      return;
    }

    const finalContent = clonedDoc.innerHTML;
    const targetContainer = document.querySelector(".target-container");
    if (targetContainer) {
      targetContainer.innerHTML = finalContent;
    }
    return finalContent;
  };
  // const handleSaveSign = () => {
  //   const modifiedString = SaveSignatureEdit();
  //   if (modifiedString === undefined) {
  //     return;
  //   } else {
  //     const parser = new DOMParser();
  //     const doc = parser.parseFromString(modifiedString, "text/html");
  //     if (imagename !== "" && imagename !== undefined && imagename !== null) {
  //       doc.querySelectorAll("img.signature").forEach((img) => {
  //         const id = img.getAttribute("data-input-id");
  //         const p = document.createElement("p");
  //         p.style.fontFamily = "'Shadows Into Light', cursive";
  //         p.style.fontSize = "18pt";
  //         p.style.fontWeight = "lighter";
  //         p.setAttribute("class", "signature");
  //         p.textContent = imagename;

  //         const parent = img.parentElement;
  //         if (parent && parent.tagName === "STRONG") {
  //           parent.replaceWith(p); // remove strong completely
  //         } else {
  //           img.replaceWith(p);
  //         }
  //       });
  //     }
  //     const finalContent = doc.body.innerHTML;
  //     const inputValues1 = {};

  //     const inputElements1 = document.querySelectorAll("input, select");
  //     let AddError = false;
  //     inputElements1.forEach((inputElement) => {
  //       const inputId1 = inputElement.getAttribute("data-input-id");
  //       const inputValue1 = inputElement.value || "";
  //       const imgElement = document.querySelector(".signature");
  //       if (
  //         (inputElement.tagName === "SELECT" &&
  //           ((inputElement.multiple &&
  //             (!inputValues1[inputId1] ||
  //               inputValues1[inputId1].length === 0)) || // Multi-select validation
  //             (!inputElement.multiple &&
  //               inputElement.value === "Please Select One"))) || // No option selected in multi-select
  //         (inputElement.type === "radio" &&
  //           !Array.from(document.getElementsByName(inputElement.name)).some(
  //             (radio) => radio.checked,
  //           )) || // No radio selected
  //         (inputElement.type !== "radio" &&
  //           inputElement.tagName !== "SELECT" &&
  //           inputValue1 === "") || // Empty text input
  //         (imgElement && imgElement.src && imgElement.src.trim() !== "")
  //       ) {
  //         AddError = true;
  //       }
  //     });
  //     setContentForSvaeSign(finalContent);

  //     if (AddError) {
  //       if (SignaturesavesignID) {
  //         dispatch(
  //           getDocFirstSave({
  //             content: finalContent,
  //             id: fileid,
  //             type: "Edit",
  //             forSign: "Yes",
  //           }),
  //         );
  //       } else {
  //         dispatch(
  //           getDocFirstSave({
  //             content: finalContent,
  //             id: fileid,
  //             type: "Add",
  //             forSign: "Yes",
  //           }),
  //         );
  //       }

  //       setSignature(true);
  //       setImage("notimage");
  //     } else {
  //       dispatch(
  //         getDocFirstSave({
  //           content: finalContent,
  //           id: fileid,
  //           type: "Edit",
  //           forSign: "Yes",
  //         }),
  //       );
  //       setSignature(true);
  //       setImage("notimage");
  //     }
  //   }
  // };
  const handleSaveSign = () => {
    // Step 1: Validate — highlights any empty fields in the UI
    // const hasError = validateForm();
    // if (hasError) {
    //   toast(<Error msg="To Sign, Fill Your Details and Save" />, {
    //     containerId: "B",
    //     className: "error_badge",
    //   });
    //   return;
    // }

    // Step 2: Serialize all live form values into the HTML string
    const modifiedString = setStringreplace();

    if (!modifiedString) {
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(modifiedString, "text/html");
    preserveSignatures(doc);
    const finalContent = doc.body.innerHTML;

    // Store the finalized content so CreateSignature receives it with all form values
    setContentForSvaeSign(finalContent);

    dispatch(
      getDocFirstSave({
        content: finalContent,
        id: fileid,
        type: "Edit",
        forSign: "Yes",
      }),
    );

    setSignature(true);
    setImage("notimage");
  };
  // ─── End of fixed handleSaveSign ────────────────────────────────────────────

  const preserveSignatures = (doc) => {
    const parser = new DOMParser();
    const signedDoc = parser.parseFromString(viewdocumentdata1, "text/html");
    signedDoc.querySelectorAll("p.signature[data-input-id]").forEach((signature) => {
      const id = signature.getAttribute("data-input-id");
      const img = doc.querySelector(
        `img.signature[data-input-id="${CSS.escape(id)}"]`,
      );
      if (!img) return;
      const parent = img.parentElement;
      const target =
        parent && parent.tagName === "STRONG" && parent.childNodes.length === 1
          ? parent
          : img;
      target.replaceWith(signature.cloneNode(true));
    });
  };

  const updateImageInDocument = (modifiedString, imagename, signatureId = null) => {
    if (!modifiedString) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(modifiedString, "text/html");

    preserveSignatures(doc);

    // Replace only the clicked placeholder; existing signatures stay unchanged.
    if (imagename && signatureId !== null) {
      const img = doc.querySelector(
        `img.signature[data-input-id="${CSS.escape(signatureId)}"]`,
      );
      if (img) {
        const p = document.createElement("p");
        p.style.fontFamily = "Shadows Into Light";
        p.style.fontSize = "18pt";
        p.style.fontWeight = "lighter";
        p.setAttribute("data-input-id", signatureId);
        p.setAttribute("class", "signature");
        p.textContent = imagename;
        const parent = img.parentElement;

        if (
          parent &&
          parent.tagName === "STRONG" &&
          parent.childNodes.length === 1
        ) {
          parent.replaceWith(p);
        } else {
          img.replaceWith(p);
        }
      }
    }

    // Make only empty table cells editable
    const tables = doc.querySelectorAll("table");
    tables.forEach((table, index) => {
      // Add unique classname for identification
      table.classList.add("editable-content-table");
      table.classList.add(`table-${index}`);
      if (!table.classList.contains("good_faith_estimate_table1")) {
        table.style.border = "1px solid #ccc";
      }
      // Add data attribute for additional identification
      table.setAttribute("data-table-id", index);

      table.setAttribute("contenteditable", "false"); // Make table non-editable
      table.style.borderCollapse = "collapse";
      table.style.margin = "10px 0";
      table.style.width = "100%";

      const cells = table.querySelectorAll("td, th");
      cells.forEach((cell, cellIndex) => {
        // Add unique identifiers to cells as well
        cell.classList.add("editable-content-cell");
        cell.setAttribute("data-table-id", index);
        cell.setAttribute("data-cell-index", cellIndex);

        if (!cell.classList.contains("good_faith_estimate_table1")) {
          cell.style.border = "1px solid #ddd";
        }

        cell.style.padding = "8px";
        cell.style.minWidth = "50px";

        // Check if cell has <p> tag
        const hasPTag = cell.querySelector("p") !== null;

        if (hasPTag) {
          // Cell has <p> tag - make it non-editable
          cell.setAttribute("contenteditable", "false");
          cell.style.backgroundColor = "#f8f9fa";
          cell.style.cursor = "not-allowed";
        } else {
          // Cell doesn't have <p> tag - make it editable
          cell.setAttribute("contenteditable", "true");
          cell.style.backgroundColor = "#fff";
          cell.style.cursor = "text";

          // Only set &nbsp; if cell is truly empty
          if (
            cell.innerHTML.trim() === "" ||
            cell.innerHTML === "<br>" ||
            cell.innerHTML === "&nbsp;"
          ) {
            cell.innerHTML = "&nbsp;";
          }
        }
      });
    });

    const finalContent = doc.body.innerHTML;
    return finalContent;
  };
  // ------------------------------Functions End-------------------------- //
  // ------------------------------UseEffect Start-------------------------- //

  // ------------------------------UseEffect Start-------------------------- //
  useEffect(() => {
    if (!imagename) {
      handleUpdate();
    }
  }, [ViewEditDocumentData]);
  // ------------------------------UseEffect End-------------------------- //

  return (
    <>
      <Modal show={show} height="100%" width="100%">
        <ModalContainer justifyContent="center">
          <ModalDialog animation={ModalAnimat}>
            <Div
              borderBottom="1px solid #2E2E2E"
              height="50px"
              padding="0px 24px 0px 24px"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              margin="0px 0px 8px 0px"
            >
              <ModalTitle
                lineHight="27px"
                fontSize="18px"
                fontWeight="600"
                color="#0a1629"
              >
                Edit Document
              </ModalTitle>
              <BsXLg
                style={{
                  color: "#407BFF",
                  cursor: "pointer",
                  height: "14px",
                  width: "14px",
                }}
                onClick={close}
              />
            </Div>
            <Div overflow="auto" padding="0px 24px 0px 24px">
              <Div padding="20px" display="flex" justifyContent="space-between">
                <ModalTitle></ModalTitle>
                <ModalTitle
                  lineHight="27px"
                  fontSize="24px"
                  fontWeight="600"
                  color="#0a1629"
                >
                  {filename}
                </ModalTitle>

                <ModalTitle
                  lineHight="27px"
                  fontSize="18px"
                  fontWeight="600"
                  color="#138808"
                >
                  Status: {filestatus}
                </ModalTitle>
              </Div>

              <div id="unique-document-viewer-123">
                <p
                  dangerouslySetInnerHTML={{
                    __html: updateImageInDocument(viewdocumentdata1),
                  }}
                />
              </div>
            </Div>
            <Div
              padding="24px"
              display="flex"
              flexDirection="row"
              margin="auto 0px 0px 0px"
            >
              {checkEditOrNot !== null && checkEditOrNot === true ? (
                <>
                  <CancelButton
                    padding="8px 24px"
                    marginLeft="auto"
                    onClick={CloseSignature}
                    id="sig_cnl-btn"
                    className="close_active"
                  >
                    Cancel
                  </CancelButton>
                  <SaveButton onClick={handleSave} className="save_active">
                    Save
                  </SaveButton>
                  {forsign === "1" && (
                    <CancelButton
                      width="150px"
                      marginLeft="20px"
                      padding="8px 9px"
                      onClick={handleSaveSign}
                    >
                      Save & Sign
                    </CancelButton>
                  )}
                </>
              ) : (
                <>
                  {forsign === "1" && (
                    <CancelButton
                      marginLeft="auto"
                      padding="8px 32px"
                      onClick={SaveSignature}
                    >
                      Sign
                    </CancelButton>
                  )}
                </>
              )}
            </Div>
          </ModalDialog>
        </ModalContainer>
      </Modal>
      {Signature && (
        <CreateSignature
          show={Signature}
          close={HanldeCloseSignature}
          closesave={HanldeCloseSignatureSave}
          closesave1={HanldeCloseSignatureSave1}
          ids={fileid}
          content={
            checkEditOrNot != null && checkEditOrNot === true
              ? ContentForSvaeSign
              : viewdocumentdata1
          }
          forIdCheck={
            checkEditOrNot != null && checkEditOrNot === true ? "no" : "yes"
          }
          image={image}
          onDataPass={handleChildData}
        />
      )}
    </>
  );
};

export default ViewEdit;
